import Slider from 'react-slick';
import { Breakpoints } from '@settings';
import StarRating from '@components/StarRating';

const sliderSettings = {
  dots: false,
  arrows: false,
  infinite: false,
  slidesToShow: 4,
  slidesToScroll: 1,
  rows: 1,
  slidesPerRow: 1,
  autoplay: true,
  autoplaySpeed: 4000,
  draggable: true,
  swipe: true,
  swipeToSlide: true,
  responsive: [
    {
      breakpoint: Breakpoints.SM,
      settings: {
        slidesToShow: 1.25,
        slidesToScroll: 1,
        autoplaySpeed: 6000,
      },
    },
    {
      breakpoint: Breakpoints.MD,
      settings: {
        slidesToShow: 2.25,
        slidesToScroll: 1,
        autoplaySpeed: 6000,
      },
    },
    {
      breakpoint: Breakpoints.XL,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplaySpeed: 6000,
      },
    },
  ],
};

export default ({ attributes, children }) => {
  console.log({ children });
  return (
    <Slider className='tw:left-1/2 tw:w-screen tw:-translate-x-1/2' {...sliderSettings}>
      {children.map(({ attributes }, index) => (
        <div
          key={index}
          className='tw:mt-[140px] tw:px-2 tw:pb-5 tw:outline-hidden tw:focus:outline-hidden tw:sm:px-3 tw:lg:px-4'>
          <div className='tw:relative tw:h-full tw:rounded-button tw:bg-[#F8F8F8] tw:px-9 tw:pb-6 tw:pt-[70px] tw:text-center tw:xs:min-h-[290px]'>
            <img
              src={attributes.image.desktop.url}
              alt=''
              className='tw:absolute tw:inset-x-0 tw:-top-[120px] tw:m-auto tw:h-full tw:max-h-[180px] tw:w-full tw:max-w-[180px] tw:object-contain tw:object-bottom'
            />

            <StarRating
              reviewRating={5}
              hideLabels
              reviewCount={9}
              starsColor='#000'
              includeAggregateRating={false}
            />

            <p className='tw:mb-0 tw:text-base'>{attributes.description}</p>

            <p className='tw:mb-0 tw:mt-7 tw:text-base tw:font-bold'>{attributes.title}</p>
          </div>
        </div>
      ))}
    </Slider>
  );
};
